import WhatsAppEnquiryForm from "@/components/feature/WhatsAppEnquiryForm";

export default function ServicesWhatsApp() {
  return (
    <section className="py-16 md:py-24 bg-[#EAF5E1]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left: Info */}
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white px-3 py-1.5 rounded-full mb-4 border border-[#7FBF3F]/20">
              Get Started
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Ready to Start Your Project?
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Tell us about your requirements and we'll connect you with the right service. Our experts are available Monday to Saturday, 11 AM to 7 PM.
            </p>
            <div className="space-y-4">
              {[
                { icon: "ri-home-4-line", title: "Residential Layout Development", desc: "End-to-end layout planning and development." },
                { icon: "ri-building-2-line", title: "Villa Plot Development", desc: "Premium villa plots with modern infrastructure." },
                { icon: "ri-user-voice-line", title: "Property Consultation", desc: "Expert guidance for smart investment decisions." },
                { icon: "ri-map-2-line", title: "Site Visit Assistance", desc: "Scheduled visits with our project team." },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4 bg-white rounded-xl p-4 border border-[#7FBF3F]/10">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#7FBF3F] text-base`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-[#1B2A4A] mb-0.5">{item.title}</p>
                    <p className="text-xs text-gray-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Form */}
          <div>
            <WhatsAppEnquiryForm />
          </div>
        </div>
      </div>
    </section>
  );
}
